import router from "@/router";
import { useLoginUserStore } from "@/store/userStore";
import ACCESS_ENUM from "@/access/accessEnum";
import checkAccess from "@/access/checkAccess";
import { useAuthModal } from "@/composables/useAuthModal";


let authEventBound = false;
if (!authEventBound) {
  window.addEventListener("komeic:auth-required", (event: Event) => {
    const detail = (event as CustomEvent<{ returnTo?: string }>).detail;
    useLoginUserStore().setLoginUser({
      userRole: ACCESS_ENUM.NOT_LOGIN,
      userName: "未登录",
    });
    useAuthModal().show("login", detail?.returnTo || router.currentRoute.value.fullPath || "/");
  });
  authEventBound = true;
}

// 进入页面前，进行权限校验
router.beforeEach(async (to) => {
  const loginUserStore = useLoginUserStore();
  let loginUser = loginUserStore.loginUser;

  // 如果之前没有获取过登录用户信息，先拉一次
  if (!loginUser || !loginUser.userRole) {
    try {
      await loginUserStore.fetchLoginUser();
    } catch (e) {
      loginUserStore.setLoginUser({
        userRole: ACCESS_ENUM.NOT_LOGIN,
        userName: "未登录",
      });
    }
    loginUser = loginUserStore.loginUser;
  }

  const needAccess = (to.meta?.access as string) ?? ACCESS_ENUM.NOT_LOGIN;

  // 不需要登录
  if (needAccess === ACCESS_ENUM.NOT_LOGIN) {
    return true;
  }

  // 需要登录，但当前未登录
  if (
    !loginUser ||
    !loginUser.userRole ||
    loginUser.userRole === ACCESS_ENUM.NOT_LOGIN
  ) {
    useAuthModal().show("login", to.fullPath);
    return false;
  }

  // 已登录但权限不足
  if (!checkAccess(loginUser, needAccess)) {
    return "/no-auth";
  }

  return true;
});
